import { t, Trans } from '@lingui/macro'
import { BackButton, ButtonOutline, Tooltip } from 'front-end/src/components'
import {
  Topbar,
  TopbarLeft,
  TopbarRight,
  TopbarTitle
} from 'front-end/src/components/common/topbar/Topbar'
import React, { useState } from 'react'
import { navigateTo } from '../../../app/util/appHistory'
import { linkBuilder } from '../../../../../shared/linkBuilder'
import { IconGridManage } from '../../../components/common/icon/IconGridManage'
import { IconVersions } from '../../../components/common/icon/IconVersions'
import { TopbarDrawer } from '../../topic-detail-page/components/drawers/TopbarDrawer'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { PathwayVersionsDrawerContent } from '../../manage-pathway-page/components/PathwayVersionsDrawerContent'
import { AdminOnlyAllowed } from '../../../components/common/AdminOnlyAllowed'

export const PathwayDetailTopbar = ({ title }: { title: string }) => {
  const history = useHistory()
  const { search } = useLocation()
  const [showVersionDrawer, setShowVersionDrawer] = useState(
    search.includes('showVersionsDrawer')
  )
  const { pathwayId, pathwayVersion } =
    useParams<{ pathwayId?: string; pathwayVersion?: string }>()

  const toggleVersionDrawer = () => {
    if (showVersionDrawer && search.includes('showVersionsDrawer')) {
      history.replace(location.pathname)
    }
    setShowVersionDrawer(!showVersionDrawer)
  }

  return (
    <>
      <Topbar>
        <TopbarLeft>
          <BackButton ml="4px" mr="4px" />
          <TopbarTitle>{title}</TopbarTitle>
        </TopbarLeft>
        <TopbarRight display={['none', 'flex']}>
          {pathwayVersion && (
            <>
              <Trans>Viewing</Trans>&nbsp;
              <strong>
                <Trans>Version</Trans>
              </strong>
              &nbsp;
              <strong>{pathwayVersion}</strong>
              <ButtonOutline
                px="12px"
                ml="8px"
                onClick={() =>
                  navigateTo(linkBuilder.pathwayDetail(Number(pathwayId)))
                }
              >
                <Trans>Show latest</Trans>
              </ButtonOutline>
            </>
          )}
          <AdminOnlyAllowed allowManagerAccess>
            {!pathwayVersion && (
              <ButtonOutline
                ml="8px"
                display={['none', 'inline-flex']}
                onClick={() =>
                  navigateTo(linkBuilder.pathwayDetailManage(Number(pathwayId)))
                }
                px="12px"
                leftIcon={<IconGridManage boxSize="18px" />}
              >
                <Trans>Manage pathway</Trans>
              </ButtonOutline>
            )}

            <Tooltip
              tabIndex={-1}
              text={<Trans>Versions</Trans>}
              aria-label={t`Versions`}
            >
              <ButtonOutline
                aria-label={
                  showVersionDrawer ? t`Hide versions` : t`Show versions`
                }
                iconOnly
                ml="8px"
                onClick={toggleVersionDrawer}
                isActive={showVersionDrawer}
              >
                <IconVersions w="18px" h="16px" />
              </ButtonOutline>
            </Tooltip>
          </AdminOnlyAllowed>
        </TopbarRight>
      </Topbar>
      <AdminOnlyAllowed allowManagerAccess>
        <TopbarDrawer
          show={showVersionDrawer}
          onHide={toggleVersionDrawer}
          title={t`Versions`}
        >
          <PathwayVersionsDrawerContent pathwayId={Number(pathwayId)} />
        </TopbarDrawer>
      </AdminOnlyAllowed>
    </>
  )
}
